// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'language-pack';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M4.304 2.058c-.64-.07-1.352-.141-2.134-.212-.64 0-1.139.424-1.139 1.06v9.397c0 .566.427 1.06.996 1.06 4.198.212 6.617 1.555 6.973 2.756.356-1.201 2.775-2.544 6.973-2.756.569 0 .996-.494.996-1.06V2.906c0-.636-.498-1.06-1.139-1.06a83.26 83.26 0 0 0-1.992.212M9 12.47v3.684' />
    <path d='M8.041 4.529v1.81H9.44a.905.905 0 1 0 0-1.81z' />
    <path d='M8.041 6.338v2.138h1.563a1.07 1.07 0 1 0 0-2.138zm6.878-1.151a.987.987 0 0 0-.931-.658h-.658a.987.987 0 0 0-.987.987v1.973c0 .545.442.987.987.987h.658c.43 0 .795-.274.93-.658m-11.837.658 1.212-3.635a.456.456 0 0 1 .866 0l1.212 3.635M3.52 7.16h2.412' />
  </g>
);

export const viewBox = '0 0 18 18';
